import { graphql, useStaticQuery } from 'gatsby';

import * as React from 'react';
import PortfolioItem from "components/PortfolioItem";

const nodeURL = 'https://www.instagram.com/p';

const ImageGallery = () => {
  const {
    allInstagramContent: { edges },
  } = useStaticQuery(graphql`
    {
      allInstagramContent(sort: { fields: timestamp, order: DESC }, limit: 12) {
        edges {
          node {
            id
            caption
            localImage {
         childImageSharp {
           fluid(maxHeight: 500, maxWidth: 500, quality: 90) {
             ...GatsbyImageSharpFluid_withWebp
           }
         }
       }
          }
        }
      }
    }
  `);

  return edges.map(({ node }) => {
    const {
      id,
      caption,
      localImage: { childImageSharp },
    } = node;
    return (
      <PortfolioItem
        key={id}
        image={childImageSharp.fluid}
        extraInfo={
          caption
        }
      />
    );
  });
};

export default ImageGallery;
